import { propOr, defaultTo, isEmpty, isNil, pipe, curryN, prop, } from 'ramda';
import { snakeCase } from 'lodash';

import keyCodes from "@constants/keyCodes";

export const isEmptyOrNil = data => isEmpty(data) || isNil(data);

export const isPresent = data => !isEmptyOrNil(data);

export const hasActiveSubscription = propOr(false, 'has_active_subscription');

export const getRandom = arr => {
  if (isEmpty(arr)) {
    return [];
  }
  return arr[Math.floor(Math.random() * Math.floor(arr.length))];
};

export const getFullName = propOr('', 'full_name');

export const getUsername = propOr('', 'username');

export const getStoryGroupAndVideoCount = propOr('', 'story_groups_and_videos_count');

export const getPhotoCount = propOr('', 'photo_count');

export const getRandomFullName = pipe(
  getRandom,
  getFullName,
);

export const dashCase = (s) => (s || '').replace(/_|-|\s+/, '-');

export const getSnakeCaseProp = curryN(2, function getSnakeCaseProp(key, data) {
  return prop(
    snakeCase(defaultTo('', key)),
    data
  )
})

export const getDashCaseProp = curryN(2, function getDashCaseProp(key, data) {
  return prop(
    dashCase(defaultTo('', key)),
    data
  )
})


export const getAnyCaseProp = curryN(2, function getAnyCaseProp(key, data) {
  const normalCase = prop(key || '', data);

  if (normalCase) {
    return normalCase
  }

  const snakeCase = getSnakeCaseProp(key, data);

  if (snakeCase) {
    return snakeCase;
  }

  const dashCase = getDashCaseProp(key, data);

  if (dashCase) {
    return dashCase;
  }

  return ''
})

export const safeAnyCaseProp = curryN(2, function getAnyCaseProp(key, defaultValue, data) {
  return defaultTo(defaultValue, getAnyCaseProp(key, data))
})


export const identifyMembers = (oneOnOneChannelState, currentUserId) => {
  const members = propOr([], 'members', oneOnOneChannelState);
  let identifiedMembers = {
    currentUser: null,
    conversationalPartner: null,
  };

  members.forEach(member => {
    switch (member.user.id) {
      case currentUserId:
        identifiedMembers.currentUser = member;
        break;
      default:
        identifiedMembers.conversationalPartner = member;
    }
  });

  return identifiedMembers;
};

export const getBroadcastChannelId = influencerStreamUserId => {
  return defaultTo('', influencerStreamUserId).split('@')[0];
};

export const activeOrCancelledSub = subscription => {
  const status = propOr('', 'status', subscription).toLowerCase();
  const subscriptionType = propOr('', 'subscription_type', subscription).toLowerCase();
  return (status == 'cancelled' || status == 'active') && subscriptionType == 'nudiez';
};

export const getPaidSubscriptions = subscriptions => {
  const defaultSubscriptions = defaultTo([], subscriptions);
  return defaultSubscriptions.filter(activeOrCancelledSub);
};

export const isMessagingDisabled = subscriptions => {
  const paidSubscriptions = getPaidSubscriptions(subscriptions);
  return isEmpty(paidSubscriptions);
};

export const sleep = ms => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

export const smoothScrollTo = (position) => {
  window.scrollTo({ top: position, behavior: 'smooth' });
}


export const isEnterKey = keyEvent => {
  const charCode = propOr("", "charCode", keyEvent);
  const keyCode = propOr("", "keyCode", keyEvent);
  return charCode === keyCodes.ENTER || keyCode === keyCodes.ENTER;
};

export const hasWhiteSpace = (s) => {
  return /\s/g.test(s);
}

export const getCsrfToken = () => {
  if (window.jQuery && window.jQuery.rails) {
    return window.jQuery.rails.csrfToken();
  }
  return window.Rails.csrfToken();
};

export const withinSuccessCodeRange = code => code >= 200 && code <= 300;
